import { cx } from '@linaria/core';
import { useRef, useEffect } from 'react';
import { typesetKatex, loadEditorLibrary } from '@utils/common';
import { BottomNavigation } from '../organism.component/integration.bottom-navigation.js';
import { TaskSection } from './molecule.task.js';
import { root } from './organism.root.style.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function IGuideContentRoot(props) {
  const currentTask = props.component.data.tasks[props.currentTaskIndex];
  const fallbackRef = useRef(null);
  const ref = props.ref ?? fallbackRef;
  useEffect(() => {
    typesetKatex(ref);

    // We would like the editor to be available as soon as possible, as it
    // most certainly will be used as an input in some of the tasks.
    loadEditorLibrary();
  }, [props.currentTaskIndex, ref]);
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    className: cx(props.className, root),
    "data-task-root": true,
    tabIndex: -1,
    children: currentTask && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(TaskSection, {
        task: currentTask,
        component: props.component
      }), props.context !== "lightbox" && /*#__PURE__*/jsx(BottomNavigation, {
        context: props.context,
        currentTask: currentTask,
        currentTaskIndex: props.currentTaskIndex,
        component: props.component,
        onNavigate: props.onNavigateTo,
        onResetEntry: props.onResetEntry
      })]
    })
  });
}

export { IGuideContentRoot };
//# sourceMappingURL=organism.root.js.map
